import { Icon, Text, Spacer, Badge } from '@oliasoft-open-source/react-ui-library';

type TCellWithExpandingIconProp = {
  cellContent: string | number | undefined;
  index: number;
  isExpanded?: boolean;
  icon?: React.ReactNode;
  leftSpace?: number;
  isBold?: boolean;
  onClick?: () => void;
  isBadge?: boolean;
  badgeColor?: string;
  badgeTextColor?: string;
  textAlign?: React.CSSProperties['textAlign'];
};
export const CellWithExpandingIcon = ({
  cellContent,
  index = 1,
  isExpanded = false,
  icon,
  leftSpace = 0,
  isBold = false,
  onClick,
  isBadge = false,
  badgeColor = '',
  badgeTextColor = '',
  textAlign = 'right',
}: TCellWithExpandingIconProp) => {
  const isFirstColumn = index === 0;
  return (
    <div
      style={{ cursor: onClick ? 'pointer' : 'default', textAlign, width: '100%', height: '100%' }}
      onClick={onClick}
    >
      {isFirstColumn && (
        <>
          <Spacer width={`${leftSpace}px`} />
          {icon || <Icon icon={isExpanded ? 'chevron down' : 'chevron right'} />}
          <Spacer width="12px" />
        </>
      )}
      {isBadge ? (
        <Badge color={badgeColor} textColor={badgeTextColor} title={cellContent} />
      ) : (
        <Text bold={isBold}>{cellContent}</Text>
      )}
    </div>
  );
};
